// extracted by mini-css-extract-plugin
export var divider = "_3q-0";
export var dividerText = "_3q-1";